import { ENTITY_URL } from "../../../config/config";
import { connection } from "../../../utils/connection";

const obtenerResultadoEncuesta = async ({ token, id, callbacks }) => {
    const response = await connection({
        method: 'GET',
        url: `${ENTITY_URL.ADMIN.ENCUESTA.RESULTADO}${id}`,
        extraHeaders: { token },
    });
    if (typeof callbacks === "function") callbacks(response);
};

export default obtenerResultadoEncuesta;
